import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20entertainment%20venue%20with%20warm%20golden%20ambient%20lighting%2C%20elegant%20stage%20with%20dramatic%20spotlights%2C%20abstract%20geometric%20patterns%20in%20gold%20and%20champagne%20tones%2C%20sophisticated%20atmosphere%2C%20cinematic%20wide%20shot%20with%20soft%20atmospheric%20haze%2C%20premium%20and%20inviting%20aesthetic&width=1920&height=1080&seq=hero-bg-sun&orientation=landscape"
          alt="太阳娱乐 - 顶级娱乐平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="mb-6 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20">
          <i className="ri-verified-badge-fill text-primary-400 text-sm"></i>
          <span className="text-sm text-background-50 font-medium">值得信赖的综合娱乐平台</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-6 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
          开启您的
          <span className="text-primary-400">精彩娱乐</span>
          之旅
        </h1>

        <p className="text-base md:text-lg text-background-50/80 mb-10 max-w-2xl mx-auto leading-relaxed">
          太阳娱乐汇聚海量精品内容，涵盖电子竞技、娱乐资讯、体育赛事、精品游戏、影视推荐等多元娱乐项目。
          安全稳定，服务专业，7×24小时全天候陪伴。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg text-base font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            立即注册
          </Link>
          <Link
            to="/categories"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg text-base font-semibold border-2 border-background-50/40 text-background-50 hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap"
          >
            探索分类
          </Link>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">5000万+</p>
            <p className="text-xs md:text-sm text-background-50/60 mt-1">注册用户</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">800万+</p>
            <p className="text-xs md:text-sm text-background-50/60 mt-1">日均活跃</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">7×24h</p>
            <p className="text-xs md:text-sm text-background-50/60 mt-1">全天候服务</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-2xl text-background-50/60"></i>
      </div>
    </section>
  );
}